import Vue from 'vue';
import {
  BootstrapVue,
  BootstrapVueIcons
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import _ from 'lodash';

import App from './App.vue';
import router from './router';
import store from './store';
import timeFilter from '@/filters/time'
// import {
//   auth
// } from '@/store/firebase.js'

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueAxios, axios);
Vue.filter('timeFilter', timeFilter);

let app;

if (!app) {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}